import * as React from 'react'
import Translation from '../../containers/Translation';
import { T_LOADING } from '../../api/translations';

import('./StatsRankingStyles.scss')   


const isRight:any = (state:boolean) => state ? 'right' : ''
const isLeft:any = (state:boolean) => state ? 'left' : ''
const isHidden:any = (state:boolean) => state ? 'hidden' : ''
const isOverlay:any = (state:boolean) => state ? 'ranking-overlay-mode' : ''


// main render function
const StatsRankingPresentation = (props:any) => {
    if( props.numRows == 0 ) {
        return (
            <div className={`ranking sr-grid sr-align-center ${isOverlay(props.rankingOverlay)}`}>
                <div className="sr-cell sr-stats-loading"><Translation tag={T_LOADING} /></div>
            </div>
        );
    }
    return (
        <div className={`ranking sr-grid ${isOverlay(props.rankingOverlay)}`}>
            {rowTemplate(props.numRows, props.rankHome, props.rankAway)}
        </div>
    )
};

const renderPositionIndicator = (position:number) => {
    return (
        <div className="position-indicator">
            <div className="position">#{position}</div>
        </div>
    )
};

const rowTemplate = (numRows:number, activeRowA:number, activeRowB:number) => {
    const elements = new Array();

    for (let i = 1; i <= numRows; i++) {
        elements.push(
            <div className="ranking-row-wrapper" key={`row-index-${i}`}>
                <div className="sr-cell sr-xs-1-3">
                    <div
                        className={`sr-content ranking-position-indicator-index-wrapper position-indicator-left ${isHidden( i !== activeRowA)}`}>
                        {renderPositionIndicator(i)}
                    </div>
                </div>
                <div className="sr-cell sr-xs-1-3">
                    <div
                        className={`sr-content ranking-row ${isRight( i === activeRowB )} ${isLeft( i === activeRowA )}`}></div>
                </div>
                <div className="sr-cell sr-xs-1-3">
                    <div
                        className={`sr-content ranking-position-indicator-index-wrapper position-indicator-right ${isHidden( i !== activeRowB)}`}>
                        {renderPositionIndicator(i)}
                    </div>
                </div>
            </div>
        )
    }
    return elements
}

export default StatsRankingPresentation
